export const slug = (str = ''): string => str.toLowerCase().replace(/ /g, '-')

export const pluralize = (count = 0, str = '', suppressCount = false): string => {
  let plural
  const lastChar = str.charAt(str.length - 1)

  if (count === 1) {
    plural = str
  } else if (lastChar === 'y') {
    plural = `${str.slice(0, -1)}ies`
  } else if (lastChar === 's') {
    plural = `${str}es`
  } else {
    plural = `${str}s`
  }

  return suppressCount ? plural : `${count.toLocaleString()} ${plural}`
}

export const commatize = (arr: string[]): string => {
  if (!arr.length) {
    return ''
  }
  if (arr.length === 1) {
    return arr[0]
  }
  if (arr.length === 2) {
    return `${arr[0]} and ${arr[1]}`
  }
  return `${arr.slice(0, arr.length - 1).join(', ')}, and ${arr[arr.length - 1]}`
}

export const capitalize = (str = ''): string => {
  const firstLetter = str.slice(0, 1)
  const remainingLetters = str
    .slice(1, str.length)
    .split('')
    .map(l => l.toLowerCase())
    .join('')
  return `${firstLetter.toUpperCase()}${remainingLetters}`
}

export const truncate = (str, len = 8, ellipses?: boolean): string => {
  return `${(str || '').substr(0, len)}${ellipses && (str || '').length > len ? '...' : ''}`
}

export const isTextMatch = (properties: string[] = [], inputText = ''): boolean => {
  const text = inputText.toLowerCase()
  return properties.map((p = '') => p.toLowerCase()).some(p => p.indexOf(text) > -1)
}
